export default class ApiUtil {
    static apiUrl = '/api';

    static restUrlFull(url) {
        return RegExp('^https?://').test(url) ? url : `${ApiUtil.apiUrl}/${url}`;
    }
}
